import { render, staticRenderFns } from "./EventTypeSelectionCard.vue?vue&type=template&id=5728649c&"
import script from "./EventTypeSelectionCard.vue?vue&type=script&lang=ts&"
export * from "./EventTypeSelectionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports